import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CustomerActivitiesSection } from "./CustomerActivitiesSection";

interface RiskCustomerModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerId: string | null;
  customerName: string | null;
}

export function RiskCustomerModal({
  isOpen,
  onClose,
  customerId,
  customerName,
}: RiskCustomerModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[94vw] h-[96vh] max-w-[98vw] grid grid-rows-[auto,1fr]">
        <DialogHeader className="shrink">
          <DialogTitle>
            {customerName ? `${customerName} - Activities` : "Customer Activities"}
          </DialogTitle>
        </DialogHeader>

        {!customerId && (
          <div className="py-4">
            Loading
          </div>
        )}
        {customerId && (
          <div className="py-4">
            <CustomerActivitiesSection customerId={customerId} />
          </div>
        )}

        <DialogFooter>
          <Button onClick={onClose} variant="outline">Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
